// extracted by mini-css-extract-plugin
export var animationContainer = "_p6-0";
export var footer = "_p6-1";
export var gray = "_p6-2";
export var lineItem = "_p6-3";
export var lineItemImage = "_p6-4";
export var lineItemInfo = "_p6-5";
export var lineItemText = "_p6-6";
export var lineItems = "_p6-7";
export var modalContent = "_p6-8";
export var options = "_p6-9";
export var orderName = "_p6-a";
export var refundAmount = "_p6-b";